import React, { useCallback, useState } from 'react';
import { Input, InputProps } from '../Input';

type Props = InputProps & {
    getValue: (data: {
        value: string | undefined,
        incomplete: boolean;
    }) => void;
}

const InputPhone: React.FC<Props> = ({ defaultValue, getValue, onChange, ...rest }) => {
    const [value, setValue] = useState<any>(defaultValue || '');

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        let result = String(e.target.value).match(/[0-9]/g)?.join('') || '';

        if (result.length > 10 && result.startsWith('55'))
            result = result.slice(2);

        if (result.length > 10 && result.startsWith('0'))
            result = result.slice(1);

        result = result.slice(0, 11);

        let formattedValue: string | undefined;

        if (result.length < 3) {
            formattedValue = result;
        } else if (result.length < 7) {
            const ddd = result.substring(0, 2);
            const rest = result.substring(2);
            formattedValue = `(${ddd}) ${rest}`;
        } else {
            const ddd = result.substring(0, 2);
            const firstPart = result.substring(2, result.length < 11 ? 6 : 7);
            const secondPart = result.substring(result.length < 11 ? 6 : 7);
            formattedValue = `(${ddd}) ${firstPart}-${secondPart}`;
        }

        setValue(formattedValue);
        getValue?.({
            value: result.length > 9 ? formattedValue : undefined,
            incomplete: result.length > 0 && result.length < 10
        });
        onChange?.(e);
    }, [getValue, onChange]);

    return (
        <Input
            {...rest}
            type="tel"
            value={value}
            onChange={handleChange}
        >
        </Input>
    );
};

export { InputPhone };
